// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__3qVrH","slider":"ToggleSwitch_slider__JVaRE","round":"ToggleSwitch_round__vqyfX"};